import React from "react";
import Moment from "react-moment";
import { useSelector } from "react-redux";

const DateFormatter = ({ date, locale }) => {
  const currentUser = useSelector((state) => state.user.user.me);
  const userLocale = locale || (currentUser && currentUser.locale) || "en";
  const format = userLocale === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY";

  return (
    <Moment
      date={date}
      format={format}
    />
  );
};

export default DateFormatter;
